import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "@/theme/ThemeProvider";
import { MSearchHotSection } from "./styles";
import { useExchangeStore } from "../../../../hooks/trade/exchangeStore";
import styled from "styled-components";
import {ListColumn} from "@/styles/Qstyle.ts";
import CoinList from "./molecules/CoinList";
import {media} from "@/styles/Qtheme.ts";
import {MobileCalVW} from "@utils/CalVW.tsx";

const MSearchHot = ({ setOpenSearch }) => {
  const { t } = useTranslation();
  const { textw } = useContext(ThemeContext).theme.COLORS;

  let { EPs } = useExchangeStore();

  return (
    <MSearchHotSection>
      <Title >
        HOT
      </Title>

      <ListColumn>
        {EPs &&
          EPs?.slice(0, 5)?.map((el, index) => (
            <CoinList key={index} data={el} trade />
          ))}
      </ListColumn>
    </MSearchHotSection>
  );
};

export default MSearchHot;


const Title = styled.div`
    font-size: 15px;
    font-weight: 500;
    color: ${({ theme }) => theme.text};
    font-family: "Pretendard",sans-serif;
    padding: 12px 20px;

    @media ${media.mobile} {
        font-size: ${MobileCalVW(15)};
    }
`